<template>
    <div class="user_grzx" v-loading="loading">
        <div class="user_box1">
            <div class="user_info">
                <div class="user_imgs">
                    <img src="@/assets/img/user_info/user_grzx/user_img.png" alt="" v-if="!user_info.avatar">
                    <img :src="user_info.avatar" alt="" v-if="user_info.avatar">
                </div>
                <div class="user_name_phone">
                    <div class="name">{{ user_info.name }}</div>
                    <div class="phone">{{ user_info.mobile }}</div>
                </div>
                <div class="urer_grade">
                    <img src="@/assets/img/user_info/user_grzx/vip.png" alt="">
                    普通会员
                </div>
            </div>
            <div class="user_orders">
                <div class="orders_lefts">
                    <div class="icons" v-for="(item,index) in icon_list" :key="index" @click="handle_path(item)">
                        <div class="imgs">
                            <img :src="item.imgs" alt="">
                        </div>
                        <div class="texts">
                            {{ item.title }}
                        </div>
                    </div>
                </div>
                <div class="orders_orders"></div>
                <div class="orders_rights">
                    <div class="icons"  @click="handle_path({path:'/user_order'})">
                        <div class="imgs">
                            <img src="@/assets/img/user_info/user_grzx/icon5.png" alt="">
                        </div>
                        <div class="texts">
                            全部订单
                        </div>
                    </div>
                </div>
              
            </div>
        </div>
        <div class="user_box2">
            <div class="box_header">
                <div class="lefts">
                    <div class="borders"></div>
                    <div class="titles">待处理服务订单</div>
                </div>
                <div class="rights">
                    <div class="btns">
                        全部订单
                        <img src="@/assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
            </div>
            <div class="order_0" v-if="order_list.length==0">
                <img src="@/assets/img/user_info/user_grzx/order_0.png" alt="">
                <div class="texts">暂无待处理订单</div>
            </div>
            <div class="order_list" v-if="order_list.length!=0">
                <div class="order_item" v-for="(item,index) in order_list" :key="index">
                    <div class="item_titles">
                        <div class="order_lefts">
                            <div class="order_time">{{ item.created_at }}</div>
                            <div class="order_no">订单号：{{ item.order_sn }}</div>
                        </div>
                        <div class="order_rights">
                            待付款
                        </div>
                    </div>
                    <div class="order_info">
                        <div class="shop_list">
                            <div class="shop_item" v-if="item.pro">
                                <div class="shop_left">
                                    <div class="shop_img">
                                        <img :src="item.pro.thumb" alt="">
                                    </div>
                                    <div class="shop_title">{{ item.pro.title }}</div>
                                </div>
                                <div class="shop_right">
                                    <div class="shop_price1">{{item.pro.price}}元</div>
                                    <div class="shop_num">X1</div>
                                    <div class="shop_price2">{{item.pro.price}}元</div>
                                </div>
                            </div>
                        </div>
                        <div class="order_btns">
                            <div class="btns_lefts">
                                <div class="text1">
                                    共
                                    <span>1</span>
                                    个商品
                                </div>
                                <div class="text2">
                                    合计金额
                                    <span> {{ item.price }}</span>
                                    元 
                                </div>
                            </div>
                            <div class="btns_right">
                                <div class="btns1"  @click="handle_deitial(item)">订单详情</div>
                                <div class="btns2" @click="handle_pay(item)">去支付</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="user_box3">
            <div class="box_header">
                <div class="lefts">
                    <div class="borders"></div>
                    <div class="titles">猜您需要</div>
                </div>
            </div>
            <div class="shop_list">
                <div class="shop_item" v-for="(item,index) in sever_list" :key="index" @click="handel_sever(item)">
                    <div class="shop_imgs">
                        <img :src="item.thumb" alt="">
                    </div>
                    <div class="shop_info">
                        <div class="shop_title">{{ item.title }}</div>
                        <div class="shop_tages">
                            <div class="tages" v-if="item.cate1">{{ item.cate1.title }}</div>
                            <div class="tages" v-if="item.cate2">{{ item.cate2.title }}</div>
                            <div class="tages" v-if="item.cate3">{{ item.cate3.title }}</div>
                        </div>
                        <div class="shop_price_nums">
                            <div class="shop_price">{{ item.price }}</div>
                            <div class="shop_nums">销量{{ item.sale_num }}</div>
                        </div>
                    </div>
                </div>
                <div class="shop_item" v-for="(item,index) in 4" :key="index"></div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
 


export default {
    props:{
        user_info:{
            type: Object,
             default: {}
		},
    },
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading:false,
            icon_list:[
                {
                    imgs:require('../../assets/img/user_info/user_grzx/icon1.png'),
                    title:'待付款',
                    path:'/user_order?types_ac=10'

                },
                {
                    imgs:require('../../assets/img/user_info/user_grzx/icon2.png'),
                    title:'服务中',
                    path:'/user_order?types_ac=30'

                },
                {
                    imgs:require('../../assets/img/user_info/user_grzx/icon3.png'),
                    title:'售后服务',
                    path:'/user_order?types_ac=30'

                },  
                {
                    imgs:require('../../assets/img/user_info/user_grzx/icon4.png'),
                    title:'待评价',
                    path:'/user_order?types_ac=50'

                }
            ],
            order_list:[],
            sever_list:[],
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_list()
        this.get_sever()
    },
    methods: {
        handle_path(item){
            this.$router.push({
                path:item.path
               
            })
        },
         get_list(){
            this.loading = true
            this.$api("myOrderList", {
                status:10,
                page:1,
                limit:2,
                is_over:1
			}, "get").then((res) => {
                this.loading = false
                console.log('我的订单列表',res)
                if (res.code == 1) {
                    this.order_list=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_sever(){
            this.loading=true
            this.$api("servePros", {
				type:1,
                page:1,
                limit:4,
			}, "get").then((res) => {
                this.loading = false
                console.log('个人法务',res)
                if (res.code == 1) {
                    this.sever_list=res.data.data
                 
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_deitial(item){
            this.$router.push({
                path:'/user_order/order_detial',
                query:{
                    id:item.id
                }
            })
        },
        handle_pay(item){
            this.$router.push({
                path:'/Legal_pay',
                query:{
                    order_id:item.id,
                    pro_id:item.pro_id
                }
            })
        },
        handel_sever(item){
            this.$router.push({
                path:'/individual_detial',
                query:{
                    id:item.id
                }
            })
        },



    },

}
</script>
<style scoped lang="less">
.user_grzx{
    .user_box1{
        display: flex;
        align-items: center;
        .user_info{
            width: 256px;
            height: 210px;
            flex-shrink: 0;
            background: url('../../assets/img/user_info/user_grzx/bg1.png');
            background-size: 100%;
            border-radius: 12px 12px 12px 12px;
            overflow: hidden;
            position: relative;
            .user_imgs{
                padding-top: 26px;
                display: flex;
                justify-content: center;
                img{
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                }
            }
            .user_name_phone{
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 12px;
                .name{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #FFFFFF;
                }
                .phone{
                    margin-left: 8px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #FFFFFF;

                }
            }
            .urer_grade{
                position: absolute;
                bottom: 1px;
                left: 1px;
                width: 254px;
                height: 48px;
                background: #FFFFFF;
                border-radius: 0px 0px 11px 11px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #377CFD;
                img{
                    width: 24px;
                    margin-right: 4px;
                }
            }
            
        }
        .user_orders{
            width: 940px;
            height: 185px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            align-items: center;
            .orders_lefts{
                width: 700px;
                flex-shrink: 0;
                display:flex;
                align-items: center;
                justify-content: space-evenly;
                .icons{
                    width: 25%;

                    .imgs{
                        cursor: pointer;

                        text-align: center;
                        img{
                            width:44px;
                        }
                    }
                    .texts{
                        cursor: pointer;

                        text-align: center;
                        padding-top: 12px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                    }
                }
            }
            .orders_orders{
                width: 0px;
                height: 69px;
                border: 1px solid #E5E5E5;
            }
            .orders_rights{
                width: 240px;
                flex-shrink: 0;
                display:flex;
                align-items: center;
                justify-content: space-evenly;
                .icons{
                    .imgs{
                        cursor: pointer;
                        text-align: center;
                        img{
                            width:33px;
                        }
                    }
                    .texts{
                        cursor: pointer;
                        text-align: center;
                        padding-top: 12px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                    }
                }
            }
        }

    }
    .user_box2{
        margin-top: 25px;
        width: 1196px;
        min-height: 337px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .box_header{
           height: 56px; 
           display: flex;
           align-items: center;
           justify-content: space-between;
           border-bottom:1px solid #DEDEDE;
           .lefts{
                height: 56px; 
                display: flex;
                align-items: center;
                .borders{
                    width: 4px;
                    height: 22px;
                    background: #377CFD;
                    border-radius: 3px 3px 3px 3px;
                }
                .titles{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #333333;
                    padding-left: 28px;
                }
           }    
           .rights{
                padding-right: 32px;
                .btns{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;
                    img{
                        width: 14px;
                        // margin-left: 8px;
                    }
                }
           }
        }
        .order_0{
            text-align: center;
            padding-top: 65px;
            img{
               width: 190px; 
            }
            .texts{
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }
        .order_list{
            padding: 32px;
            .order_item{
                width: 1132px;
                min-height: 260px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                margin-bottom: 22px;
                .item_titles{
                    width: 1132px;
                    height: 44px;
                    background: #F5F5F5;
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #E5E5E5;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding:0 24px ;
                    .order_lefts{
                        display: flex;
                        align-items: center;
                        .order_time{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                            margin-right: 20px;
                        }
                        .order_no{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                        }
                    }
                    .order_rights{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;

                    }
                }
                .order_info{
                    padding:0 24px;
                    padding-top: 24px;
                    .shop_list{
                        
                        border-bottom: 1px solid #E5E5E5;
                        .shop_item{
                            margin-bottom: 24px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .shop_left{
                                display: flex;
                                align-items: center;
                                .shop_img{
                                    width: 104px;
                                    height: 104px;
                                    img{
                                        width: 104px;
                                        height: 104px;
                                    }
                                }
                                .shop_title{
                                    padding-left: 24px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;
                                }
                            }
                            .shop_right{
                                display: flex;
                                align-items: center;
                                .shop_price1{
                                    width: 150px;
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;

                                }
                                .shop_num{
                                    width: 100px;
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;
                                }
                                .shop_price2{
                                    width: 150px;
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;


                                }
                            }
                        }
                    }
                    .order_btns{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 64px;
                        .btns_lefts{
                            display: flex;
                            align-items: center;
                            .text1{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                span{
                                    color: #377CFD;
                                    font-weight: bold;
                                }
                            }
                            .text2{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                margin-left: 20px;
                                span{
                                    color: #377CFD;
                                    font-weight: bold;

                                }
                            }
                        }
                        .btns_right{
                            display: flex;
                            align-items: center;
                            .btns1{
                                width: 104px;
                                height: 32px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                line-height: 32px;
                                text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                                cursor: pointer;
                            }   
                            .btns2{
                                width: 104px;
                                height: 32px;
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px;
                                text-align: center;
                                line-height: 32px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFFFFF;
                                cursor: pointer;
                                margin-left: 10px;
                            }

                        }
                    }
                    

                }
            }
        }
    }
    .user_box3{
        width: 1196px;
        height: 431px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 24px;
        .box_header{
           height: 56px; 
           display: flex;
           align-items: center;
           justify-content: space-between;
           border-bottom:1px solid #DEDEDE;
           .lefts{
                height: 56px; 
                display: flex;
                align-items: center;
                .borders{
                    width: 4px;
                    height: 22px;
                    background: #377CFD;
                    border-radius: 3px 3px 3px 3px;
                }
                .titles{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #333333;
                    padding-left: 28px;
                }
           }    
           .rights{
                padding-right: 32px;
                .btns{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;
                    img{
                        width: 14px;
                        // margin-left: 8px;
                    }
                }
           }
        }
        .shop_list{
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            padding:  32px;
            .shop_item{
                width: 262px;
                cursor: pointer;
                .shop_imgs{
                    img{
                        width: 262px;
                        height: 196px;
                    }
                }
                .shop_info{
                    padding-top: 13px;
                    .shop_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                    } 
                    .shop_tages{
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        padding-top: 13px;

                        .tages{
                            padding: 4px 10px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 9px;
                            color: #FFAA00;
                            background: #FDF6EC;
                            border-radius: 3px 3px 3px 3px;
                            border: 1px solid #FFAA00;
                            margin-right: 8px;
                        }
                    }
                    .shop_price_nums{
                        display: flex;
                        align-items: end;
                        justify-content: space-between;
                        padding-top: 16px;
                        .shop_price{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 25px;
                            color: #FD4C5C;
                        }
                        .shop_nums{
                            
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #999999;

                        }
                    }
                }
            }   
        }
    }
}

</style>